import { render, staticRenderFns } from "./NB.vue?vue&type=template&id=b6fb512a&scoped=true&"
import script from "./NB.vue?vue&type=script&lang=js&"
export * from "./NB.vue?vue&type=script&lang=js&"
import style0 from "./NB.vue?vue&type=style&index=0&id=b6fb512a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6fb512a",
  null
  
)

export default component.exports